import ApiService from '../services/ApiService';
import { STORAGE_KEYS } from '../constants';

export function setMpCheckoutPedidoId(pedidoId) {
  if (!pedidoId) return;
  try {
    sessionStorage.setItem(STORAGE_KEYS.MP_CHECKOUT_PEDIDO_ID, pedidoId);
  } catch (_) {
    // ignore
  }
}

export function clearMpCheckoutPedidoId() {
  try {
    sessionStorage.removeItem(STORAGE_KEYS.MP_CHECKOUT_PEDIDO_ID);
  } catch (_) {
    // ignore
  }
}

export function getMpCheckoutPedidoId() {
  try {
    return sessionStorage.getItem(STORAGE_KEYS.MP_CHECKOUT_PEDIDO_ID);
  } catch (_) {
    return null;
  }
}

export async function cancelarCheckoutMercadoPago(pedidoId, paymentId) {
  if (!pedidoId) {
    return { cancelled: false };
  }

  const query = paymentId ? `?payment_id=${encodeURIComponent(paymentId)}` : '';
  const respuesta = await ApiService.post(
    `/pedidos/${pedidoId}/cancelar-checkout${query}`,
    {},
    { withAuth: false }
  );

  return {
    cancelled: Boolean(respuesta?.data?.deleted),
    reason: respuesta?.data?.reason || null,
  };
}

export async function cancelarCheckoutPendienteEnSesion(paymentId) {
  const pedidoId = getMpCheckoutPedidoId();
  if (!pedidoId) {
    return { cancelled: false };
  }

  try {
    const result = await cancelarCheckoutMercadoPago(pedidoId, paymentId);
    if (result.cancelled || result.reason === 'not_found' || result.reason === 'not_found_after_payment_check') {
      clearMpCheckoutPedidoId();
    }
    return { ...result, pedidoId };
  } catch (error) {
    console.error('[mpCheckoutSession] Error al cancelar checkout:', error);
    return { cancelled: false, pedidoId, error };
  }
}
